import { render } from "./proxyConfig.vue?vue&type=template&id=4b94219c&scoped=true"
import script from "./proxyConfig.vue?vue&type=script&lang=js"
export * from "./proxyConfig.vue?vue&type=script&lang=js"

import "./proxyConfig.vue?vue&type=style&index=0&id=4b94219c&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b94219c"]])

export default __exports__